import active_citized from "../assets/fonts/active-citizen.f1afbc46.svg";
import active_cso from "../assets/fonts/active-cso.02a389cb.svg";
import active_project_carousel from "../assets/fonts/active-project-carousel.a208020c.svg";
import active_project_map from "../assets/fonts/active-project-map.af215f79.svg";
import appstore from "../assets/fonts/appstore.a7430883.svg";
import arrowForwardGreen from "../assets/fonts/arrowForwardGreen.18e45e7d.svg";
import back_arrow from "../assets/fonts/backarrow.svg";
import calender from "../assets/fonts/calender.70e8f990.svg";
import categoryIcon from "../assets/fonts/categoryIcon.74aa3493.svg";
import checkList from "../assets/fonts/checkList.df5a571f.svg";
import citizen from "../assets/fonts/citizen.84bae387.svg";
import cso from "../assets/fonts/cso.c91072b9.svg";
import darkCaret from "../assets/fonts/darkCaret.25ee4a91.svg";
import discoverIcon from "../assets/fonts/discoverIcon.dc325422.svg";
import doubleArrow from "../assets/fonts/doubleArrow.596ce5ab.svg";
import empty from "../assets/fonts/empty.svg";
import eyeEmoji from "../assets/fonts/eyeEmoji.6b974b02.svg";
import facebook from "../assets/fonts/facebook.97234b5d.svg";
import faqCaret from "../assets/fonts/faqCaret.2b5ed3e0.svg";
import faqMotif from "../assets/fonts/faqMotif.5d6dfe90.svg";
import features from "../assets/fonts/features.3714c93e.svg";
import featuresMotif from "../assets/fonts/featuresMotif.c8af642d.svg";
import featuresMotifMobile from "../assets/fonts/featuresMotifMobile.ab611fc0.svg";
import folder from "../assets/fonts/folder.svg"
import filterAdd from "../assets/fonts/filterAdd.ed4053fe.svg";
import getStarted from "../assets/fonts/getStarted.8cf2f3de.svg";
import goldGradientCaret from "../assets/fonts/goldGradientCaret.e11a297a.svg";
import greenCaret from "../assets/fonts/greenCaret.a14cc74a.svg";
import greenGradientCaret from "../assets/fonts/greenGradientCaret.4b50abab.svg";
import green_caret_right from "../assets/fonts/grey-caret-right.f2818630.svg";
import green_caret from "../assets/fonts/grey-caret.547f1833.svg";
import harmburger from "../assets/fonts/harmburger.b6257175.svg";
import heroMotif from "../assets/fonts/heroMotif.36145ce0.svg";
import hiddenEye from "../assets/fonts/hiddenEye.b208788b.svg";
import hiking from "../assets/fonts/hiking.0d626b06.svg";
import instagram from "../assets/fonts/instagram.276195b9.svg";
import landingMotif from "../assets/fonts/landingMotif.951df702.svg";
import linkedin from "../assets/fonts/linkedin.c8933999.svg";
import login_logo_green from "../assets/fonts/login-logo-green.09c57af5.svg";
import login_motif_1 from "../assets/fonts/login-motif-1.3163bb89.svg";
import login_motif_2 from "../assets/fonts/login-motif-2.f88b7a1f.svg";
import marketing from "../assets/fonts/marketing.cd2c25b7.svg";
import menu_white from "../assets/fonts/menu-white.ad4588a8.svg";
import menu from "../assets/fonts/menu.bd48213b.svg";
import ministriesIcon from "../assets/fonts/ministriesicon.cbdfddde.svg";
import more_icon_dark from "../assets/fonts/more-icon-dark.6441d6e3.svg";
import motivation from "../assets/fonts/motivation.5b1ea3ae.svg";
import negative from "../assets/fonts/negative.svg";
import neutral from "../assets/fonts/neutral.svg";
import no_photo from "../assets/fonts/no_photo.svg";
import playstore from "../assets/fonts/playstore.454948e6.svg";
import positive from "../assets/fonts/positive.svg";
import project_carousel from "../assets/fonts/project-carousel.f90b3a0d.svg";
import project_map from "../assets/fonts/project-map.a600c013.svg";
import scrollDown from "../assets/fonts/scrollDown.68930c0e.svg";
import searchIcon from "../assets/fonts/searchIcon.d0ff39c5.svg";
import search_icon from "../assets/fonts/search.svg";
import sectorsIcon from "../assets/fonts/sectorsicon.3504d1be.svg";
import separator from "../assets/fonts/separator.b19041fb.svg";
import stakeholders from "../assets/fonts/stakeholders.4a39503b.svg";
import statesIcon from "../assets/fonts/statesicon.43cffd8a.svg";
import textLogo from "../assets/fonts/textLogo.781c68bc.svg";
import troubleshooting from "../assets/fonts/troubleshooting.31fc5290.svg";
import twitter from "../assets/fonts/twitter.41671c76.svg";
import userInterface from "../assets/fonts/userInterface.03f434db.svg";
import white_search from "../assets/fonts/white-search.bc50a395.svg";
import whiteCaret from "../assets/fonts/whiteCaret.5444e822.svg";
import whiteTextLogo from "../assets/fonts/whiteTextLogo.e0dd0780.svg";
import winner from "../assets/fonts/winner.e996e91c.svg";
import no_comment from '../assets/images/no_comment.png'

const IconSVG = {
	active_citized,
	active_cso,
	active_project_carousel,
	active_project_map,
	appstore,
	arrowForwardGreen,
	back_arrow,
	calender,
	categoryIcon,
	checkList,
	citizen,
	cso,
	darkCaret,
	discoverIcon,
	doubleArrow,
	empty,
	eyeEmoji,
	facebook,
	faqCaret,
	faqMotif,
	features,
	featuresMotif,
	featuresMotifMobile,
	filterAdd,
	folder,
	getStarted,
	goldGradientCaret,
	greenCaret,
	greenGradientCaret,
	green_caret_right,
	green_caret,
	harmburger,
	heroMotif,
	hiddenEye,
	hiking,
	instagram,
	landingMotif,
	linkedin,
	login_logo_green,
	login_motif_1,
	login_motif_2,
	marketing,
	menu_white,
	menu,
	ministriesIcon,
	more_icon_dark,
	motivation,
	negative,
	neutral,
	no_photo,
	playstore,
	positive,
	project_carousel,
	project_map,
	searchIcon,
	scrollDown,
	sectorsIcon,
	separator,
	stakeholders,
	statesIcon,
	search_icon,
	textLogo,
	troubleshooting,
	twitter,
	userInterface,
	white_search,
	whiteCaret,
	whiteTextLogo,
	winner,
	no_comment
}

export default IconSVG;